import { ENC } from "@/constants/testIds";
import { formatDate } from "@/lib/patientChart";
import { hasVersionHistory, noteDisplayStatus, visibleEncounterNotes } from "@/lib/noteApi";

function statusClass(status) {
  return status === "signed"
    ? "bg-emerald-50 text-emerald-800"
    : "bg-amber-50 text-amber-800";
}

export default function EncounterNotesList({ notes = [], selectedNoteId, onSelect }) {
  const visible = visibleEncounterNotes(notes);
  if (!visible.length) {
    return (
      <div
        data-testid={ENC.screenNoteList}
        className="rounded-lg border border-dashed border-slate-200 bg-white px-3 py-4 text-xs text-slate-500"
      >
        No notes yet. Create a Note, or start SOAP / Diagnosis to document a Visit Note.
      </div>
    );
  }

  return (
    <div data-testid={ENC.screenNoteList} className="overflow-hidden rounded-lg border border-slate-200 bg-white">
      <table className="w-full text-left text-xs">
        <thead className="bg-slate-50 text-[11px] uppercase tracking-wide text-slate-500">
          <tr>
            <th className="px-3 py-2 font-semibold">Type</th>
            <th className="px-3 py-2 font-semibold">Title</th>
            <th className="px-3 py-2 font-semibold">Status</th>
            <th className="hidden px-3 py-2 font-semibold sm:table-cell">Version</th>
            <th className="hidden px-3 py-2 font-semibold md:table-cell">Created</th>
          </tr>
        </thead>
        <tbody>
          {visible.map((note) => {
            const status = noteDisplayStatus(note);
            const selected = note.id === selectedNoteId;
            const version = note.currentVersion;
            return (
              <tr
                key={note.id}
                data-testid={`${ENC.screenNoteRow}-${note.id}`}
                onClick={() => onSelect?.(note)}
                className={`cursor-pointer border-t border-slate-100 ${
                  selected ? "bg-sky-50" : "hover:bg-slate-50"
                }`}
              >
                <td className="px-3 py-2 font-semibold text-slate-800">
                  {note.noteType?.displayName || "Note"}
                </td>
                <td className="max-w-[10rem] truncate px-3 py-2 text-slate-600">
                  {note.title || "—"}
                </td>
                <td className="px-3 py-2">
                  <span className={`rounded px-1.5 py-0.5 font-semibold uppercase ${statusClass(status)}`}>
                    {status}
                  </span>
                  {hasVersionHistory(note) ? (
                    <span className="ml-1 text-[10px] uppercase tracking-wide text-slate-400">History</span>
                  ) : null}
                </td>
                <td className="hidden px-3 py-2 text-slate-500 sm:table-cell">
                  {version ? `V${version.versionNumber}` : "—"}
                </td>
                <td className="hidden px-3 py-2 text-slate-500 md:table-cell">
                  {note.createdAt ? formatDate(note.createdAt, "MMM d, yyyy h:mm a") : "—"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
